import { Button, Form, Modal } from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  dispatchtoast,
  getLocalStorageItem,
  mobilePattern,
} from "../../../../Utils";
import {
  AepsUPIcashWithdrawal,
  AepsUPIcashWithdrawalCheckStatus,
} from "../../../../ApiServices/Apifun";
import { useDispatch, useSelector } from "react-redux";
import ReportDrawer from "../../../../Common/ReportDrawer";
import { setselectedTab } from "../../../../Store/B2bslice";
import CommonInput from "../../../../Common/CommonInput";

const UPIcashWithdrawal = () => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [openReceiptDrawer, setOpemReceiptDrawer] = useState(false);
  const [form] = Form.useForm();
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const dispatch = useDispatch();
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [qrImage, setQrImage] = useState("");
  const [qrData, setQrData] = useState(null);
  const [qrTimer, setQrTimer] = useState(60);
  const [amount, setAmount] = useState("");
  const [messageModalOpen, setMessageModalOpen] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageTitle, setMessageTitle] = useState("");
  const [messageText, setMessageText] = useState("");
  const [transactionID, setTransactionID] = useState(null);
  const statusIntervalRef = useRef(null);
  const firstStatusTimeoutRef = useRef(null);

  const stopStatusPolling = () => {
    if (statusIntervalRef.current) {
      clearInterval(statusIntervalRef.current);
      statusIntervalRef.current = null;
    }
    if (firstStatusTimeoutRef.current) {
      clearTimeout(firstStatusTimeoutRef.current);
      firstStatusTimeoutRef.current = null;
    }
  };

  const stopQRProcess = () => {
    stopStatusPolling();
  };

  const showSuccessModal = (res) => {
    stopQRProcess();
    setQrModalOpen(false);
    setMessageType("success");
    setMessageTitle("Payment Successful");
    setMessageText(res?.message || "UPI payment completed successfully.");
    setMessageModalOpen(true);
    if (res?.data) {
      setResponse(res.data);
    }
  };

  const showExpiredModal = () => {
    stopQRProcess();
    setQrModalOpen(false);
    form.resetFields();
    setAmount("");

    setMessageType("expired");
    setMessageTitle("Payment Failed");
    setMessageText("The QR code has expired. Please try again.");
    setMessageModalOpen(true);
  };

  const checkUPIStatus = async (data) => {
    try {
      const formdata = new FormData();
      formdata.append("transaction_id", data?.merchantTransactionId || "");
      const res = await AepsUPIcashWithdrawalCheckStatus(formdata);
      console.log("UPI Check Status Response:", res);
      if (!res?.status) {
        return;
      }
      if (res?.transaction_status == 1) {
        showSuccessModal(res);
        return;
      }
      if (res?.message == 0) {
        return;
      }

      if (res?.message == 2) {
        showExpiredModal();
        return;
      }
    } catch (error) {
      console.log("UPI Check Status Error:", error);
    }
  };

  const startStatusPolling = (data) => {
    stopStatusPolling();

    firstStatusTimeoutRef.current = setTimeout(() => {
      checkUPIStatus(data);

      firstStatusTimeoutRef.current = null;

      statusIntervalRef.current = setInterval(() => {
        checkUPIStatus(data);
      }, 5000);
    }, 10000);
  };

  useEffect(() => {
    if (!qrModalOpen || qrTimer <= 0) {
      return;
    }
    const timer = setInterval(() => {
      setQrTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [qrModalOpen, qrTimer]);

  useEffect(() => {
    if (qrModalOpen && qrTimer <= 0) {
      showExpiredModal();
    }
  }, [qrTimer, qrModalOpen]);

  useEffect(() => {
    dispatch(setselectedTab("3.6"));

    return () => {
      stopQRProcess();
    };
  }, []);

  const handleUPIcashWithdrawal = (val) => {
    setBtnLoading(true);
    stopQRProcess();
    const payload = {
      customer_name: val.customer_name,
      customer_mobile: val.customer_mobile,
      amount: val.amount,
      latitude: getLocalStorageItem("latitude"),
      longitude: getLocalStorageItem("longitude"),
      deviceType: "Web",
    };
    const formdata = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      formdata.append(key, value);
    });
    AepsUPIcashWithdrawal(formdata)
      .then((res) => {
        if (res?.status && res?.data?.intentLink) {
          setQrData(res.data);
          setTransactionID(res.data?.merchantTransactionId);
          const imageSrc = `data:image/png;base64,${res.data.intentLink}`;
          setQrImage(imageSrc);
          setQrTimer(res?.data?.qrExpiryIn || 60);
          setQrModalOpen(true);
          setAmount(val.amount);
          startStatusPolling(res.data);
        } else {
          dispatchtoast(
            res?.message ?? "Something Went Wrong. Please Try Again",
            true,
          );
        }
      })
      .catch((err) => {
        console.log("UPI Cash Withdrawal Error:", err);
      })
      .finally(() => {
        setBtnLoading(false);
      });
  };

  const handleCloseQRModal = () => {
    stopQRProcess();
    setQrModalOpen(false);
  };
  const handleCloseMessageModal = () => {
    setMessageModalOpen(false);
    setMessageType("");
    setMessageTitle("");
    setMessageText("");
  };

  const handleRetry = () => {
    setMessageModalOpen(false);
    setMessageType("");
    setMessageTitle("");
    setMessageText("");
    setQrData(null);
    setQrImage("");
    setQrTimer(60);
    form.resetFields();
    setAmount("");
  };

  const Content = () => {
    if (!response) return null;
    return (
      <>
        <div className="border-2 rounded-md w-9/12 border-dashed border-gray-500 ml-4 mr-4 text-center mt-5">
          <p className="-mt-2 bg-white w-[100px] flex justify-center items-center font-semibold m-auto text-[11px]">
            Transaction I'd
          </p>

          <p className="text-[11px] mt-2 mb-2">{response.transaction_id}</p>
        </div>

        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4">
          <div className="flex justify-between items-center">
            <p>Balance Amount</p>

            <p className="text-black">{response.amount} Rs.</p>
          </div>
        </div>

        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4">
          <div className="flex justify-between items-center">
            <p>Merchant Name</p>

            <p className="text-black">{response.merchant_name}</p>
          </div>
        </div>

        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4">
          <div className="flex justify-between items-center">
            <p>Bank Name</p>

            <p
              style={{
                wordBreak: "break-word",
              }}
              className="text-black"
            >
              {response.bank_name}
            </p>
          </div>
        </div>

        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4">
          <div className="flex justify-between items-center">
            <p>Aadhar Number</p>

            <p className="text-black">{response.masked_aadhaar}</p>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal rounded-3xl p-5">
          <p className="font-bold text-[15px] mb-2">UPI Cashpoint</p>

          <Form
            form={form}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => handleUPIcashWithdrawal(val)}
          >
            <Form.Item
              name={`customer_name`}
              label={"Name"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Name!",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your Name"
                onInput={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                  e.target.value = value;
                }}
                name="customer_name"
              />
            </Form.Item>
            <Form.Item
              name={`customer_mobile`}
              label={"Mobile Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Mobile Number!",
                },
                {
                  pattern: mobilePattern,
                  message: "Invalid mobile number format!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your Mobile Number"
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                name="customer_mobile"
              />
            </Form.Item>
            <Form.Item
              name="amount"
              label="Amount"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Amount!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Amount"
                name="amount"
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");

                  e.target.value = value;
                }}
              />
            </Form.Item>

            <Form.Item>
              <Button
                loading={btnLoading}
                className="w-full bg-primary border-none mt-4"
                style={{ color: "white" }}
                htmlType="submit"
              >
                Send
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>

      <Modal
        open={qrModalOpen}
        onCancel={handleCloseQRModal}
        footer={null}
        centered
        title="Scan UPI QR"
        width={400}
      >
        <div className="flex flex-col items-center justify-center">
          {qrImage && (
            <img
              src={qrImage}
              alt="UPI QR Code"
              className="w-[300px] h-[300px] object-contain"
            />
          )}
          <p className="text-center font-bold text-2xl mt-1 text-black">
            ₹{amount ?? "-"}
          </p>

          <p className="text-center mt-3 text-gray-600">
            Please ask the customer to scan this QR code.
          </p>

          <p
            className={`text-center font-medium mt-1 ${qrTimer <= 10 ? "text-red-600" : "text-red-500"
              }`}
          >
            {qrTimer > 0
              ? `QR will expire in ${qrTimer} seconds`
              : "QR has expired"}
          </p>

          {qrData?.vpa && (
            <p className="text-center mt-2">
              VPA: <strong>{qrData.vpa}</strong>
            </p>
          )}
        </div>
      </Modal>

      <Modal
        open={messageModalOpen}
        onCancel={handleCloseMessageModal}
        footer={null}
        centered
        closable
        width={400}
      >
        <div className="flex flex-col items-center justify-center text-center py-6">
          <div
            className={`w-16 h-16 rounded-full flex items-center justify-center text-3xl mb-4 ${messageType === "success"
                ? "bg-green-100 text-green-600"
                : "bg-red-100 text-red-600"
              }`}
          >
            {messageType === "success" ? "✓" : "!"}
          </div>

          <h2 className="text-lg font-semibold">{messageTitle}</h2>

          <p className="text-gray-500 text-sm mt-2 px-5">{messageText}</p>

          <Button
            className="w-full bg-primary border-none mt-4"
            style={{ color: "white" }}
            onClick={
              messageType === "expired" ? handleRetry : handleCloseMessageModal
            }
          >
            {messageType === "expired" ? "Try Again" : "OK"}
          </Button>
        </div>
      </Modal>

      {openReceiptDrawer && (
        <ReportDrawer
          title="UPI Cashpoint Receipt"
          open={openReceiptDrawer}
          setOpen={setOpemReceiptDrawer}
          content={<Content />}
        />
      )}
    </>
  );
};

export default UPIcashWithdrawal;
